import { render } from "./proformaForm.vue?vue&type=template&id=4d19167c&scoped=true"
import script from "./proformaForm.vue?vue&type=script&lang=js"
export * from "./proformaForm.vue?vue&type=script&lang=js"

import "./proformaForm.vue?vue&type=style&index=0&id=4d19167c&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d19167c"]])

export default __exports__